import { render, staticRenderFns } from "./BookingPurchaseSummary.vue?vue&type=template&id=6c543f55&"
import script from "./BookingPurchaseSummary.vue?vue&type=script&lang=js&"
export * from "./BookingPurchaseSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports